import { Flex, getTopNavigationHeight } from '@taxbit-private/cosmic'
import { Suspense, lazy } from 'react'
import styled from 'styled-components'

import { useUser } from 'contexts/UserContext'

import LeftRail from './LeftRail'
import TopNavigationBar from './TopNavigationBar'

const CommandPanel = lazy(() =>
  import('components/cmdk').then((m) => ({ default: m.CommandPanel }))
)

type LayoutProps = {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user } = useUser()

  return (
    <>
      <TopNavigationBar />
      <SFlex>
        <LeftRail />
        <ScrollableContainer>{children}</ScrollableContainer>
      </SFlex>
      {user?.isSuperAdmin && (
        <Suspense fallback={null}>
          <CommandPanel />
        </Suspense>
      )}
    </>
  )
}

export default Layout

const ScrollableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`

const SFlex = styled(Flex)(
  ({ theme }) => `
    height: calc(100vh - ${getTopNavigationHeight(theme)});
  `
)
